import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import "./PlaygroundLayout.css";
import { useDispatch, useSelector } from "react-redux";
import { selectIsGameOver, selectLevel } from "store/game/selectors";
import { selectUser } from "store/user/selectors";
import { checkIfPartsAreValid } from "pages/home/Levels";
import GameOver from "pages/playground/GameOver";
import { LazyMotion, domAnimation } from "framer-motion";
import { exitGame } from "store/game";

export default function PlaygroundLayout() {
  const dispatch = useDispatch();

  const selectedLevel = useSelector(selectLevel);
  const user = useSelector(selectUser);
  //   const location = useLocation();

  //   useEffect(() => {
  //     return () => {
  //       dispatch(exitGame());
  //     };
  //   }, [dispatch]);

  if (
    !selectedLevel ||
    !user?.username ||
    !checkIfPartsAreValid(selectedLevel?.parts)
  ) {
    return <Navigate to="/setup" replace />;
  }

  return (
    <LazyMotion features={domAnimation}>
      <main className="w-screen h-screen bg-game-gradient text-slate-50 text-sm relative flex items-center justify-center">
        <Outlet />
      </main>
    </LazyMotion>
  );
}
